import { useState } from 'react'
import Box from '@mui/material/Box'

import { Address } from '@ecm/data/Address'
import AddressesMap from '@ecm/ui/component/addresses/AddressMap'
import Button from '@ecm/ui/element/Button'
import CloudflareImage from '@ecm/ui/element/CloudflareImage'
import { MapReferenceProvider } from '@ecm/ui/provider/MapReferenceProvider'

import mapPlaceholder from '/public/images/maps/mapPlaceholder.webp'

type MapWithPlaceholderProps = {
  addresses: Address[]
}

export const MapWithPlaceholder = ({ addresses }: MapWithPlaceholderProps) => {
  const [showInteractiveMap, setShowInteractiveMap] = useState(false)

  const loadInteractiveMap = () => {
    if (showInteractiveMap) {
      return
    }

    setShowInteractiveMap(true)
  }
  return (
    <>
      {showInteractiveMap ? (
        <MapReferenceProvider>
          <AddressesMap addresses={addresses} />
        </MapReferenceProvider>
      ) : (
        <Box position="relative" height="600px">
          <CloudflareImage
            src={mapPlaceholder}
            layout="fill"
            objectFit="cover"
            priority
            unoptimized
          />
          <Box position="absolute" top="50%" left="50%" sx={{ transform: 'translate(-50%,-50%)' }}>
            <Box textAlign="center">
              <CloudflareImage
                src="/images/illustration/location-pin.svg"
                width={100}
                height={100}
                priority
              />
            </Box>
            <Button primary onClick={loadInteractiveMap}>
              Show on map
            </Button>
          </Box>
        </Box>
      )}
    </>
  )
}

export default MapWithPlaceholder
